function debounce(func, wait, options = {}) {
  let timeout;

  return function executedFunction(...args) {
    const context = this;

    const later = () => {
      timeout = null;
      if (!options.leading) {
        func.apply(context, args);
      }
    };

    const shouldCallNow = options.leading && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);

    if (shouldCallNow) {
      func.apply(context, args);
    }
  };
}

export default debounce;
